import S from "../shared.module.scss";
import CategoriesList from "@/views/service-center/components/service-main/categories-list";
import SearchInput from "@/views/service-center/components/service-main/search-input";
import { useTranslations } from "next-intl";
import { FC, useState } from "react";
import { useRouter } from "next/navigation";
import { ServiceCenterPageCategoriesResource } from "@/api/generated-api";

interface IServiceMain {
  title: string;
  description: string;
  categories: ServiceCenterPageCategoriesResource[];
}

const ServiceMain: FC<IServiceMain> = ({ title, description, categories }) => {
  const router = useRouter();
  const [searchValue, setSearchValue] = useState("");
  const t = useTranslations();

  const searchArticleHandler = () => {
    if (searchValue.length >= 3) router.push(`/service-center/search?q=${searchValue}`);
  };

  return (
    <div className={S.mainWrapper}>
      <div className={S.topContent}>
        <h2 className={S.slogan}>{title}</h2>
        <h3 className={S.subtitle}>{description}</h3>
        <SearchInput
          $variant="black"
          value={searchValue}
          placeholder={t("findByArticle")}
          onChange={v => setSearchValue(v)}
          onSubmit={searchArticleHandler}
        />
      </div>
      <CategoriesList categories={categories} />
    </div>
  );
};

export default ServiceMain;
